import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSendSMS() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      mobile: isEmpty(state.mobile),
      id: isEmpty(state.id),
    };

    setter(errorState);

    if (errorState.mobile || errorState.id) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (state.mobile.length < 11) {
      errorState.mobile = true;
      enqueueSnackbar("لطفا شماره موبایل را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  function validate2(state, setter) {
    let errorState = {
      message: isEmpty(state.message),
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.message || errorState.title) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetMessages = (bool, callback) => {
    MyAxios.get(`Admin_ManualSMS`, {
      headers: {
        IsPage: bool ? true : false,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SendSMS = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_ManualSMS`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const GetBunchList = (bool, callback) => {
    MyAxios.get(`Admin_ManualSMS/bunch`, {
      headers: {
        IsPage: bool ? true : false,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const setBunch = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_ManualSMS/bunch`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const deleteBunch = (SMSId, callback) => {
    const data = new FormData();
    data.append("ID", SMSId);
    MyAxios.delete(`Admin_ManualSMS/bunch`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };
  const setTemplate = (Model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    MyAxios.post(`Admin_ManualSMS/template`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت ارسال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const deleteTemplate = (SMSId, callback) => {
    const data = new FormData();
    data.append("ID", SMSId);
    MyAxios.delete(`Admin_ManualSMS/template`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("باموفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  return {
    validate,
    GetMessages,
    SendSMS,
    GetBunchList,
    setBunch,
    deleteBunch,
    setTemplate,
    deleteTemplate,
    validate2,
  };
}
